<template lang="pug">
  div#mc-subscribe-container
    form(v-if="!this.successMessage" @submit.prevent="subscribe($event)")
      input(v-model="email" name="EMAIL" type="text" placeholder="Type your email" id="email")
      button.submit(type="submit")
    p(v-if="this.errorMessage && !this.successMessage" transition="fade") {{ this.errorMessage }}
    p(v-if="this.successMessage" transition="fade") {{ this.successMessage }}
</template>

<script>

import Vue from 'vue'
import axios from 'axios'

// component instance
var mcSubscribe = Vue.component('mcSubscribe', {
  name: 'mcSubscribe',
  props: ['action'],
  data: function () {
    return {
      email: '',
      response: {},
      errorMessage: null,
      successMessage: null
    }
  },
  ready () {
    this.action = this.action.replace('/post?', '/post-json?').concat('&c=?')
  },
  methods: {
    subscribe (e) {
      axios({
        method: 'get',
        url: this.action,
        data: JSON.stringify(this.email),
        cache: false,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8'
      })
        .then(res => {
          if (res.result === 'success') {
            this.successMessage = res.msg
          } else {
            this.errorMessage = res.msg
            this.errorMessage = this.errorMessage.substring(this.errorMessage.indexOf('-') + 1, this.errorMessage.length)
          }
        })
        .catch(error => {
          // this.errorMessage = error
          console.error(error)
        })
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default mcSubscribe
</script>

<style lang="scss" scoped>
#mc-subscribe-container{
  position: relative;
}

input{
  max-width: 270px;
  margin-top: 2.3rem;

  &[type='text']{
    height: 55px;
    font-size: 100%;
    color: #fff;
    background: transparent;
    border: none;
    outline: none;
    border-bottom: 1px solid #ADB7FF;
    border-radius: 0;
    padding-left: 1rem;
    box-shadow: none;
    &:focus{
      outline: none;
      box-shadow: none;
    }
  }
}
button.submit{
  position: absolute;
  top: 0;
  left: 270px;
  width: 55px;
  height: 55px;
  // background: #fff;

  cursor: pointer;

  transition: background .2s ease-in-out;

  &:hover{
    background: #DEDEFF;
  }

  &:after{
    content: '';
    position: absolute;
    width: 13px;
    height: 13px;
    top: calc(50% - 6px);
    left: calc(50% - 10px);
    border-right: 1px solid $white;
    border-bottom: 1px solid $white;
    transform: rotate(-45deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mcSubscribe.vue